import React from 'react';
import PropTypes from 'prop-types';

import { SelectableItemView } from '@bingads-webui-campaign-react/smart-component-primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  unSelectedClassName: {
    borderColor: 'transparent',
  },
  itemContainer: {
    padding: '16px 12px 16px 21px',
  },
});

function UnStyledPickerCell({
  classes,
  className,
  defaultState,
  item,
  ItemComponent,
  updateSelectedState,
  i18n,
  selectable,
}) {
  const onChange = () => {
    updateSelectedState({ id: item.id });
  };
  const onRenderItem = () => (
    <div className={classes.itemContainer}>
      <ItemComponent
        item={item}
        i18n={i18n}
      />
    </div>
  );

  return (
    <SelectableItemView
      item={item}
      selectable={selectable}
      selected={defaultState}
      onChange={onChange}
      onRenderItem={onRenderItem}
      unSelectedClassName={classes.unSelectedClassName}
      className={className}
    />
  );
}

UnStyledPickerCell.defaultProps = {
  selectable: true,
};

UnStyledPickerCell.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  ItemComponent: PropTypes.func.isRequired,
  defaultState: PropTypes.bool.isRequired,
  updateSelectedState: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  className: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    unSelectedClassName: PropTypes.string.isRequired,
  }).isRequired,
  selectable: PropTypes.bool,
};

export const PickerCell = withDefaultStyles(
  UnStyledPickerCell,
  getStyles
);
